import { memo } from "react";
import { AlertTriangle, ChevronRight } from "lucide-react";

interface SuspiciousAlertProps {
  message: string;
  onClick?: () => void;
  variant?: "warning" | "danger";
}

export const SuspiciousAlert = memo(function SuspiciousAlert({ 
  message, 
  onClick,
  variant = "danger"
}: SuspiciousAlertProps) {
  const colorClasses = variant === "danger" 
    ? "bg-[#F5F5F5] text-[#D15B46] hover:bg-[#EAEAEA]" 
    : "text-amber-600";
  
  const iconBgClass = variant === "danger" 
    ? "bg-[#D15B46]" 
    : "bg-amber-600";
  
  return (
    <div
      className={`flex items-center ${onClick ? 'justify-between' : ''} gap-2 rounded-sm p-1 ${onClick ? colorClasses + ' cursor-pointer transition-colors' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-center gap-2">
        <div className={`w-5 h-5 rounded-full ${iconBgClass} flex items-center justify-center`}>
          <AlertTriangle className="h-3 w-3 text-white" />
        </div>
        <span className={`text-sm font-medium ${variant === "danger" ? "text-[#D15B46]" : "text-amber-600"}`}>
          {message}
        </span>
      </div>
      {onClick && (
        <ChevronRight className={`h-4 w-4 ${variant === "danger" ? "text-[#D15B46]" : "text-amber-600"}`} />
      )}
    </div>
  );
});
